import Enumerator from '../global/Enumerator';

export const ticketStatusTypes = [
  'CREATED',
  'STALE',
  'PAUSED',
  'SUBMITTED',
  'LODGED',
  'CONDITIONALLY_APPROVED',
  'APPROVED',
  'SETTLED',
  'WON',
  'WITHDRAWN',
  'DECLINED',
  'LOST'
];

export class TicketStatusType extends Enumerator {
  static default() {
    return this.of('IN_PROGRESS');
  }
}
TicketStatusType.initEnum({
  CREATED: {
    get term() {
      return 'Created';
    },
    get prop() {
      return 'isActive';
    },
    get propTime() {
      return 'timeStamp';
    }
  },
  STALE: {
    get term() {
      return 'Stale';
    },
    get prop() {
      return 'isRotten';
    },
    get propTime() {
      return 'rottenTimeStamp';
    }
  },
  PAUSED: {
    get term() {
      return 'Paused';
    },
    get prop() {
      return 'isFrozen';
    },
    get propTime() {
      return 'frozenTimeStamp';
    }
  },
  SUBMITTED: {
    get term() {
      return 'Submitted';
    },
    get prop() {
      return 'isSubmitted';
    },
    get propTime() {
      return 'submittedTimeStamp';
    }
  },
  LODGED: {
    get term() {
      return 'Lodged';
    },
    get prop() {
      return 'isLodged';
    },
    get propTime() {
      return 'lodgedTimeStamp';
    }
  },
  CONDITIONALLY_APPROVED: {
    get term() {
      return 'ConditionallyApproved';
    },
    get prop() {
      return 'isConditionallyApproved';
    },
    get propTime() {
      return 'conditionallyApprovedTimeStamp';
    }
  },
  APPROVED: {
    get term() {
      return 'Approved';
    },
    get prop() {
      return 'isApproved';
    },
    get propTime() {
      return 'approvedTimeStamp';
    }
  },
  SETTLED: {
    get term() {
      return 'Settled';
    },
    get prop() {
      return 'isSettled';
    },
    get propTime() {
      return 'settledTimeStamp';
    }
  },
  WON: {
    get term() {
      return 'Won';
    },
    get prop() {
      return 'isWon';
    },
    get propTime() {
      return 'wonTimeStamp';
    }
  },
  WITHDRAWN: {
    get term() {
      return 'WithDrawn';
    },
    get prop() {
      return 'isWithDrawn';
    },
    get propTime() {
      return 'withDrawnTimeStamp';
    }
  },
  DECLINED: {
    get term() {
      return 'Declined';
    },
    get prop() {
      return 'isDeclined';
    },
    get propTime() {
      return 'declinedTimeStamp';
    }
  },
  LOST: {
    get term() {
      return 'Lost';
    },
    get prop() {
      return 'isLost';
    },
    get propTime() {
      return 'lostTimeStamp';
    }
  },
  IN_PROGRESS: {
    get term() {
      return 'Expected';
    },
    get prop() {
      return 'isInProgress';
    },
    get propTime() {
      return 'values.onceOffDueDate';
    }
  }
});

export default {
  ticketStatusTypes,
  TicketStatusType
};
